import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ArrowRight, CheckCircle2, Clock, XCircle, Repeat } from "lucide-react";

const STYLE = {
  swapped: { label: "SWAPPED", cls: "text-bt-positive border-bt-positive/40", Icon: Repeat },
  queued: { label: "QUEUED FOR OPEN", cls: "text-bt-gold border-bt-gold/40", Icon: Clock },
  rejected: { label: "AI SAID NO", cls: "text-bt-text-tertiary border-bt-border-subtle", Icon: XCircle },
  keep: { label: "KEPT", cls: "text-bt-text-secondary border-bt-border-subtle", Icon: CheckCircle2 },
};
const pct = (v) => `${v >= 0 ? "+" : ""}${Number(v || 0).toFixed(1)}%`;

const VerdictRow = ({ v }) => {
  const s = STYLE[v.verdict] || STYLE.keep;
  return (
    <div className="py-3 border-b border-bt-border-subtle last:border-0" data-testid={`reopt-row-${v.symbol}`}>
      <div className="flex items-center gap-2 flex-wrap">
        <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-mono border ${s.cls}`} data-testid={`reopt-verdict-${v.symbol}`}>
          <s.Icon className="w-3 h-3" />{s.label}
        </span>
        <span className="font-mono text-sm text-bt-text-primary">{v.symbol}</span>
        {v.replacement && (v.verdict !== "keep") && (
          <><ArrowRight className="w-3.5 h-3.5 text-bt-text-tertiary" /><span className="font-mono text-sm text-bt-gold">{v.replacement.symbol}</span></>
        )}
        <span className="ml-auto font-mono text-[11px] text-bt-text-tertiary">
          {pct(v.pnl_pct)} entry · {pct(v.momentum)} today · score {v.score}
          {v.replacement?.score != null && v.verdict !== "keep" ? ` vs ${v.replacement.score}` : ""}
        </span>
      </div>
      <p className="text-xs text-bt-text-secondary font-body mt-1">{v.why}</p>
      {v.ai_reason && <p className="text-xs text-bt-text-tertiary font-body italic mt-0.5">AI: {v.ai_reason}</p>}
    </div>
  );
};

export default function ReoptimizeResultsDialog({ result, onClose }) {
  if (!result) return null;
  const order = { swapped: 0, queued: 1, rejected: 2, keep: 3 };
  const rows = [...result.verdicts].sort((a, b) => order[a.verdict] - order[b.verdict]);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl bg-bt-surface border-bt-border-subtle max-h-[85vh] overflow-y-auto" data-testid="reopt-results-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-bt-text-primary">Reoptimize results</DialogTitle>
          <DialogDescription className="font-body text-bt-text-secondary" data-testid="reopt-summary">{result.summary}</DialogDescription>
        </DialogHeader>
        <div className="flex gap-4 font-mono text-xs text-bt-text-tertiary" data-testid="reopt-counts">
          <span>Reviewed {result.verdicts.length}</span>
          <span className="text-bt-positive">Swapped {result.swapped}</span>
          <span className="text-bt-gold">Queued {result.queued}{result.already_queued ? ` (+${result.already_queued} already)` : ""}</span>
        </div>
        <div>{rows.map(v => <VerdictRow key={v.symbol} v={v} />)}</div>
      </DialogContent>
    </Dialog>
  );
}
